import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;